import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.2/js/sparta-events-utility";
import widgetEventsUtility from "utilities/global/sparta-widget-events-utility/1.0.0/js/sparta-widget-events-utility";
import spartaBootstrapUtility from "utilities/global/sparta-bootstrap-utility/4.3.0/js/sparta-bootstrap-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import currentWidgetDetails from "utilities/platform/widget-details";




const defaults = {};





const EVENTS = {
  GLOBAL_READY: spartaBootstrapUtility.EVENTS.SPARTA_GLOBAL_READY,
  WIDGET_READY: 'SPARTA_WIDGET_READY.spartaWidgetUtility',
};





class Widget {




  constructor(options = {}) {

    this.settings = Object.assign({}, defaults, options);


    this.name = null;
    this.version = null;
    this.containers = null;
    this.fadeInOnReady = true;
    this.widgetLoaded = false;


    this.spartaStore = spartaStoreUtility;
    this.spartaEvents = spartaEventsUtility;
    this.widgetEvents = widgetEventsUtility;


    this.bindSuperClassEvents();
  }


  get container() {
    return this.containers[0] || null;
  }






  get EVENTS() {
    return EVENTS;
  }





  bindSuperClassEvents() {
    this.globalReadySubToken = this.spartaEvents.sub(this.EVENTS.GLOBAL_READY, this.emitWidgetReady.bind(this));
  }






  emitWidgetReady() {

    this.spartaEvents.unsubByToken(this.globalReadySubToken);


    const { name, version } = spartaStoreUtility.getData('applicationContext');


    const preContainers = spartaStoreUtility.getData('applicationContainer');
    const containers = Array.isArray(preContainers) ? preContainers : [preContainers];


    this.name = name;
    this.version = version;
    this.containers = containers;


    this.widgetEvents.pub(this.EVENTS.WIDGET_READY, { widget: { name: this.name, version: this.version } });


    this.widgetReady();


    if (!this.widgetLoaded) {
      this.widgetLoaded = true;


      this.widgetEvents.sub("refreshWidget", function(event) {
        if (event.detail.name === this.name && event.detail.version === this.version) {
          this.refreshWidget(event);
        }
      }.bind(this));
    }
  }





  widgetReady() {

    if (this.fadeInOnReady) {
      this.containers.forEach((currentContainer) => {
        const loadingElement = currentContainer.querySelector('.sparta-widget');

        loadingElement.classList.add('sparta-animate-fade-in');
        currentContainer.classList.remove('sparta-widget-loading');
      })
    }


    this.removeWidgetParentSpinner();
  }






  refreshWidget(event) {

  };





  removeWidgetParentSpinner() {
    this.containers.forEach((currentContainer) => {
      currentContainer.style.visibility = 'visible';
      currentContainer.parentNode.classList.remove('sparta-widget-loading');
    });
  }
}

export default Widget;
